export default __webpack_public_path__ + "static/media/SolidColorBanner.4a733ea5.png";